let DEVICE_ID_REGEXP = /^(\d+)-([RD])(-[a-f\d]{2}){2}(-[a-f\d]{3})([a-f\d]{7,})$/i;

export default function deviceIdValidator() {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$validators.integer = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                if (DEVICE_ID_REGEXP.test(viewValue)) {
                    // it is valid
                    return true;
                }

                // it is invalid
                return false;
            };
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/device_add/device-id-validator.js
 **/